import React from "react";
import {useDispatch} from "react-redux";
import styles from "./WorkerDescriptionModal.module.scss";
import {Field, Form, Formik} from "formik";
import {Button} from "@mui/material";
import {salonManagementActions} from "../../../../store";
import TextField from "../../../../../Common/TextField";
import { useTranslation } from 'react-i18next';

export default ({closeModal, worker}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  return (
    <Formik
      initialValues={worker}
      onSubmit={(values) => {
        const req = {
          idPoltrona: values.id,
          descrizionePoltrona: values.description,
        }
        dispatch(salonManagementActions.EDIT_WORKER.REQUEST(req, closeModal))
      }}
    >
      {() => (
        <Form className={styles.closures_modal_wrapper}>
          <Field
            name={'description'}
            id={'description'}
            label={t('workers.workerDescriptionModal.description')}
            component={TextField}
            textarea={true}
            height={'180px'}
            margin={'0px 0px 40px 0px'}
            placeholder={t('workers.workerDescriptionModal.placeholder')}
          />
          <div className={styles.actions_container}>
            <Button
              className={styles.confirm_button}
              variant="contained"
              type={'submit'}
            >
              {t('common.actions.save')}
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
}